import React, { createContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../configs/api';

export const SocketContext = createContext();

const newSocket = io(SOCKET_URL);
export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    
    setSocket(newSocket);

    newSocket.on('user-list', data => {
        
      setUsers(data);
      localStorage.setItem('users', JSON.stringify(data));
    });

    newSocket.on('call-ended', () => {
      console.log('Call ended in SocketContext');
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, users }}>
      {children}
    </SocketContext.Provider>
  );
};
